import { useEffect, useRef, useState } from "react";
import { Modal, TouchableOpacity, View } from "react-native";
import CustomText from "./CustomText";
import { android, web } from "./Platform";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
const DropDownButton = (props) => {
  let { options = [], value = null, onSelect = () => {}, width = 75 } = props,
    [optionDetails, setOptionDetails] = useState({
      visible: false,
      top: 0,
      left: 0,
      opacity: 0,
    }),
    [selectedOption, setSelectedOption] = useState([]),
    OptionButton = useRef();
  useEffect(() => {
    try {
      let isSelectedOption = [{ value: 0, label: "Select" }];
      if (value) {
        isSelectedOption = options.filter(
          (state) =>
            state["value"].toString().toLowerCase() ===
            value?.toString().toLowerCase()
        );
      }
      setSelectedOption(isSelectedOption);
    } catch (error) {}
  }, [value]);
  const handleOpenOption = () => {
    OptionButton.current.measure((_fx, _fy, _w, h, _px, py) => {
      setOptionDetails({
        visible: true,
        top: py + h - (android ? 22 : 0),
        left: _px - 1,
        width: _w - 30,
        opacity: 1,
      });
    });
  };

  return (
    <View
      style={{
        zIndex: 2,
        alignSelf: "center",
      }}
    >
      <TouchableOpacity
        ref={OptionButton}
        activeOpacity={1}
        onPress={handleOpenOption}
        style={{
          zIndex: 111,
          paddingVertical: 2,
          paddingHorizontal: 5,
          borderRadius: 3,
          borderWidth: 1,
          width,
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <CustomText
          style={{
            fontSize: 12,
            alignItems: "center",
          }}
        >
          {selectedOption[0]?.["label"]}
        </CustomText>
        <Icon
          size={web ? 17 : 15}
          name={`chevron-${optionDetails["visible"] ? "up" : "down"}`}
        />
      </TouchableOpacity>

      <Modal
        visible={optionDetails["visible"]}
        transparent
        animationType="fade"
      >
        <TouchableOpacity
          activeOpacity={1}
          style={{
            height: "100%",
          }}
          onPress={() => setOptionDetails({ ...optionDetails, visible: false })}
        >
          <View
            style={[
              {
                backgroundColor: "#fff",
                position: "relative",
                zIndex: 2,
                borderColor: "#d3dadf",
                borderWidth: 2,
                boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                width,
              },
              {
                top: optionDetails["top"],
                left: optionDetails["left"],
                opacity: optionDetails["opacity"],
              },
            ]}
          >
            <>
              {options.map((item, index) => (
                <CustomText
                  onPress={() => {
                    onSelect(item);
                    setOptionDetails({ ...optionDetails, visible: false });
                  }}
                  key={index}
                  style={{
                    paddingVertical: 5,
                    paddingHorizontal: 10,
                    fontSize: 12,
                    alignItem: "center",
                    backgroundColor:
                      selectedOption[0]?.["value"] == item["value"]
                        ? "#f2f2f2"
                        : "#fff",
                  }}
                >
                  {item.label}
                </CustomText>
              ))}
            </>
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

export default DropDownButton;
